import { PureComponent } from 'react'
import _ from 'lodash'
import { Flag } from 'flag'
import styles from './SidePane.css'

import { NavLink } from 'react-router-dom'
import { Icon } from '@vzmi/shp_shared_compo'
import Card from '../Common/Card'
import { isPathInPrivilegedPages } from '../../lib/authWrapper'

/**
 * exclude list for routes
 * PS: 新的 route 已經改成 /dashboard
 * 但是傳到這裡要對照 privilege 所以轉換成舊的 hash route
 * 如果前端改 privilege，供應商也需要重新設定因此在這裡做兼容
 */
const EXCLUDE_ROUTE_LIST = [
  '/#dashboard'
]

export const excludeRouteByPrivilegedPages = (routePath, privilegedPages) => {
  if (_.some(EXCLUDE_ROUTE_LIST, (v) => v === routePath)) {
    // if input route path is in exclude route list, then check if it's in PrvilegedPages
    // return true for `excluded`, return false for `not excluded`
    return !isPathInPrivilegedPages(routePath, privilegedPages)
  }
  return false
}

const isPathActive = routeConfig => (match, location) => {
  const currentPath = routeConfig.path
  return currentPath === location.pathname
}

const FlagWrapper = ({ flagName, children }) =>
  flagName ? <Flag name={flagName}>{children}</Flag> : children

class SidePane extends PureComponent {
  render () {
    const { supplier, page, routes } = this.props
    const { sharedLink } = supplier
    const { scmHomepage } = sharedLink
    const { privilegedPages } = page

    return (
      <div
        className={styles.sidePane}
        data-role='dashboard-side-pane'
      >
        <Card
          className={styles.dashboardLinks}
          data-role='dashboard-link'
        >
          <ul>
            {
              routes.map((routeConfig, idx) => {
                const currentPath = _.replace(routeConfig.path, /^\//, '/#')
                // 將列表中的route path排除
                // if input route path is in exclude route list, then check if it's in PrvilegedPages
                // return true for `excluded`, return false for `not excluded`
                const hideThisRoute = excludeRouteByPrivilegedPages(currentPath, privilegedPages)
                return (
                  !hideThisRoute && (
                    <FlagWrapper
                      key={idx}
                      flagName={routeConfig.flagName}
                    >
                      <li>
                        <NavLink
                          to={routeConfig.path}
                          activeClassName='active'
                          isActive={isPathActive(routeConfig)}
                        >
                          <Icon
                            name={routeConfig.icon}
                            size={29}
                          />
                          <span>{routeConfig.text}</span>
                        </NavLink>
                      </li>
                    </FlagWrapper>
                  )
                )
              })
            }
            <li data-role='scm-link'>
              <a
                href={scmHomepage}
                target='_blank'
                rel="noreferrer"
              >
                <Icon
                  name='arrow-right'
                  size={29}
                />
                <span>SCM 首頁</span>
              </a>
            </li>
          </ul>
        </Card>
      </div>
    )
  }
}

export default SidePane
